<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Tipo de Mensagem Automática</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="description">
                      <span class="required">*</span> Título/Identificação:
                    </label>
                    <input autocomplete="new-password" type="text" id="description" class="form-control"
                      v-model="message_type.description" />
                  </div>

                  <div class="form-group col-md-6">
                    <label for="inputUser">
                      <span class="required">*</span> Status:
                    </label>
                    <select v-model="message_type.status" class="form-control">
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="callStatus">Vincular a Status do Chamado</label>
                    <v-select v-model="message_type.call_status_id" :options="allstatus"
                      :reduce="status => status.status" :label="'description'" />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="message">
                      <span class="required">*</span> Conteúdo da Mensagem:
                    </label>
                    <small class="form-text text-muted mb-2">
                      Este é o texto que será inserido nos chamados ao usar a mensagem automática.
                    </small>
                    <ckeditor :editor="editor" v-model="message_type.name" :config="editorConfig" class="form-control"
                      placeholder="Digite aqui o conteúdo da mensagem que será preenchida automaticamente...">
                    </ckeditor>
                  </div>
                </div>
                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>

                <div class="block text-right mb-1">
                  <router-link to="/message_types" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue2";

export default {
  name: "imageUpload",
  components: {
    BaseCrud,
    vSelect,
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      message_type: {
        name: "",
        description: "",
        status: 1,
        call_status_id: null,
      },
      allstatus: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'blockQuote',
            'insertTable',
            'undo',
            'redo'
          ]
        },
        language: 'pt-br',
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
          ]
        }
      },
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "message_types";

      if (self.message_type.id) {
        api += "/" + self.message_type.id;
        self.message_type._method = "PUT";
      }

      axios
        .post(api, self.message_type)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/message_types");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getmessage_type: function (id) {
      const self = this;
      const api = self.$store.state.api + "message_types/" + id;

      axios
        .get(api)
        .then((response) => {
          self.message_type = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getAllStatus() {
      const self = this;
      const api = self.$store.state.api + "statusCall";

      axios
        .get(api)
        .then((response) => {
          self.allstatus = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getAllStatus();

    if (id) {
      self.getmessage_type(id);
    }
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

/* Estilos para o CKEditor */
.ck-editor__editable_inline {
  min-height: 200px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.ck.ck-editor__main>.ck-editor__editable {
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.ck.ck-editor__main>.ck-editor__editable:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
